import * as React from "react";

// Shared CTA (design guide §6): every button is the same size — primary blue, 13px/24px padding,
// 600 weight, 15px text, 10px radius, full-width on mobile. Where side-by-side buttons must match
// a fixed width (e.g. the itinerary toggle's 230px) pass a literal class: className="md:w-[230px]"
// (Tailwind only generates classes it can see statically).
const VARIANTS = {
    primary: "bg-emp hover:bg-emp_dark text-white",
    secondary: "bg-white border border-content_4 text-content_1 hover:bg-emp_soft",
    success: "bg-green text-white",
    payment: "bg-payment hover:opacity-90 text-white",
};

export default function Button({
    variant = "primary",
    fullWidthMobile = true,
    className = "",
    children,
    ...rest
}) {
    const width = fullWidthMobile ? "w-full md:w-auto" : "";
    return (
        <button
            className={`inline-flex items-center justify-center px-6 py-[13px] text-[15px] font-semibold rounded-btn
                transition-colors disabled:opacity-50 disabled:cursor-not-allowed
                ${VARIANTS[variant] || VARIANTS.primary} ${width} ${className}`}
            {...rest}
        >
            {children}
        </button>
    );
}
